import { BehaviorSubject } from 'rxjs';
import { Injectable } from "@angular/core";
import { NdmsSafeSubscriber } from "../../../../../shared/core/interfaces/ndms-safe-subscriber";
import { JpatsPolicyAuthorizationService } from "../../../api/services/jpats-policy-authorization.service";      //to replace
//import { PermissionsService } from '../../api/services/permissions.service';
import { PermissionModel } from '../../../api/models/permission-model';

@Injectable()
export class JpatsPolicyPermissionsService extends NdmsSafeSubscriber {
  private _effectivePermissions = new BehaviorSubject({ permissions: [], organizationId: undefined });
  get effectivePermissions$() {
    return this._effectivePermissions.asObservable();
  }
  get effectivePermissions() {
    return this._effectivePermissions.value || { permissions: [], organizationId: undefined };
  }

  private _missingPermissions$ = new BehaviorSubject({ permissions: [], organizationId: undefined });
  get missingPermissions$() {
    return this._missingPermissions$.asObservable();
  }
  get missingPermissions() {
    return this._missingPermissions$.value;
  }

  allPermissions: PermissionModel[] = [];

  static PermissionSets = {
    Core: [
      'Jpats:Patient:Authentication:Access',
      'Jpats:Patient:Authentication:Save',
      'Jpats:Patient:FCC:Access',
      'Jpats:Patient:FCC:Save',
      'Jpats:Patient:Location:Access',
      'Jpats:Patient:Location:Save',
      'Jpats:Patient:Manifest:Access',
      'Jpats:Patient:Manifest:Save',
      'Jpats:Patient:Operation:Access',
      'Jpats:Patient:Operation:Save',
      'Jpats:Patient:Patients:Access',
      'Jpats:Patient:Patients:Save',
      'Jpats:Report:Dashboard:Access',
      'Jpats:Report:Dashboard:Save',
      'Jpats:Report:Location:Access',
      'Jpats:Report:Location:Save',
      'Jpats:Report:Patients:Access',
      'Jpats:Report:Patients:Save',
      'Jpats:User:Access',
      'Jpats:User:Save',
      'Jpats:Admin:Access',
      'Jpats:Admin:Save'
    ]
  };

  constructor(private policyAuthorizationService: JpatsPolicyAuthorizationService) { //}, private permissionsService: PermissionsService) {
    super();
  }

  hasAnyPermissions(permissionNames: string[], organizationId?: number) {
    return !!permissionNames.find((permissionName) => this.hasPermission(permissionName));
  }

  hasAllPermissions(permissionNames: string[], organizationId?: number) {
    let results = permissionNames.filter((permissionName) => this.hasPermission(permissionName));
    return results.length === permissionNames.length;
  }

  hasPermission(permissionName, organizationId?: number) {
    if (!permissionName) {
      return false;
    }

    return !!this.effectivePermissions.permissions.find(i => i.permissionName === permissionName || i.permissionName === 'System:Root');
  }

  async loadEffectivePermissions(permissions: string[], organizationId?: number): Promise<any> {
    if (organizationId && organizationId !== this.effectivePermissions.organizationId) {
      this._effectivePermissions.next({ permissions: [], organizationId: undefined });
      this._missingPermissions$.next({ permissions: [], organizationId: undefined });
    }

    let missingPermissions = permissions.filter((permission) => !!!this.effectivePermissions.permissions.find(i => i.permissionName === permission));
    if (missingPermissions.length === 0 && this.effectivePermissions.permissions.length > 0) {
      return Promise.resolve(this.effectivePermissions);
    }

    let filteredMissingPermissions = missingPermissions.filter(permission => !!!this.missingPermissions.permissions.find(i => i === permission));

    if (filteredMissingPermissions && filteredMissingPermissions.length === 0) {
      return Promise.resolve(this.effectivePermissions);
    }

    let params: JpatsPolicyAuthorizationService.EvaluateParams = {
      permissions: filteredMissingPermissions || [],
      organizationId: organizationId
    };

    let effectivePermissions = await this.policyAuthorizationService.Evaluate(params).toPromise();
    let currentEffectivePermissions = this.effectivePermissions;
    if (effectivePermissions) {
      currentEffectivePermissions.permissions = currentEffectivePermissions.permissions.concat(effectivePermissions);
      this._effectivePermissions.next(currentEffectivePermissions || { permissions: [], organizationId: null });
      missingPermissions = missingPermissions.filter(permission =>
        !!!currentEffectivePermissions.permissions.find(i => i.permissionName === permission));
      this._missingPermissions$.next({ permissions: missingPermissions, organizationId: organizationId });
    }

    return currentEffectivePermissions;
  }

  // async loadPermissionsByApplication(application: string) : Promise<any> {
  //   let applicationPermissions = this.allPermissions.filter((permission) =>
  //     permission.applicationName.toLocaleLowerCase() === application.toLocaleLowerCase());
  //   if (applicationPermissions.length > 0) {
  //     return Promise.resolve(applicationPermissions);
  //   }
  //   let permissions = await this.permissionsService.GetPermissionsByApplication(application).toPromise();
  //   this.allPermissions = [...permissions];
  //   return this.allPermissions;
  // }


  hasSystemRoot(effectivePermissions) {
    return !!effectivePermissions.permissions.find((permission) => permission.permissionName === 'System:Root');
  }
}
